// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getIsEditingOrderWithAssistant = (state: ReduxStateShared): boolean =>
  state.checkout.editOrderWithAssistant;
